import { styled } from "@mui/material/styles";
import { PaperCollapse, paperCollapseClasses } from "@surfaces/PaperCollapse";

const PREFIX = "ModalContactPaperCollapse";

export const classes = {
  root: `${PREFIX}-root`,
  blackTitle: `${PREFIX}-blackTitle`,
};

export const ModalContactPaperCollapse = styled(PaperCollapse)(({ theme }) => ({
  [`&.${classes.root}`]: {
    [`& .${paperCollapseClasses.paperButtonContent} .${classes.blackTitle}`]: {
      color: theme.palette.common.black,
    },
    [`& .${paperCollapseClasses.collapse}`]: {
      boxShadow:
        "0px 1px 3px 0px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.14)",
    },
    [`& .${paperCollapseClasses.paperButton}`]: {
      boxShadow:
        "0px 1px 3px 0px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.14)",
    },
  },
}));
